import { createAction, props } from '@ngrx/store';
import { User } from 'src/typings';
import { DeviceTypeEnum } from 'src/enums';
import { DeviceInfo } from 'ngx-device-detector';

export const loginUser = createAction(
  'LOGIN',
  props<{ payload: { info: User | undefined | null } }>()
);

export const changeWindowWith = createAction(
  'CHANGE_WIDTH',
  props<{ payload: { device_type: DeviceTypeEnum } }>()
);

export const updateDeviceInfo = createAction(
  '[Device] Update Device Info',
  props<{ deviceInfo: DeviceInfo }>()
);

export const updateUser = createAction('CHANGE_USER', props<{ payload: User }>());

export const updateFiscalSession = createAction(
  '[User] Update fiscal session',
  props<{ userId: number; fiscalId: number; isSessionOpen: boolean }>()
);

export const setLoading = createAction('SET_LOADING', props<{ payload: boolean }>());

export const logoutUser = createAction('LOGOUT');
